/**
 * Internal component option for roots that render outside their parent's layout.
 * Slot consumers can exclude overlays without importing their implementations or
 * requiring callers to change the natural parent-anchored nesting contract.
 */
export const OUT_OF_FLOW_CONTENT: unique symbol = Symbol('out-of-flow-content');
